const changeItemStatus = async (data) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/Items/UpdateItemStatus/${data.itemId}`,
      {
        method: "POST",
        body: JSON.stringify(`${data.itemStatus}`),
        headers: { "Content-Type": "application/json" },
      }
    );
    if (response.status === 204) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};
export default changeItemStatus;
